import React from "react";
import "./styles.scss";

const Index = (props) => (
  <>
    <div className={"footer-inner-menu-wrp d-flex d-flex flex-column justify-content-center"}>
      {!props.isFooterOnly && (
        <div className={"footer-menu-inner-wrp d-flex justify-content-between"}>
          <div className={"f-menu animate__animated animate__fadeInDown"}>FAQ</div>
          <div className={"f-menu animate__animated animate__fadeInDown"}>Offers</div>
          <div className={"f-menu animate__animated animate__fadeInDown"}>Our products</div>
          <div className={"f-menu animate__animated animate__fadeInDown"}>Reach us</div>
          <div className={"f-menu animate__animated animate__fadeInDown"}>Rates and charges</div>
        </div>
      )}

      {/*{props.isFooterOnly &&*/}
      {/*<div className={'best-view-wrapper d-flex flex-column justify-content-center '}>*/}
      {/*    <div className={'bv-icon-wrapper d-flex justify-content-center'}>*/}
      {/*        <div className={'bv-img animate__animated animate__fadeInDown'}>*/}
      {/*            <img className={'lbl-logo animate__animated animate__fadeIn'}*/}
      {/*                 src={require("../../../assets/img/IE.png")}*/}
      {/*                 alt="NTB online banking"/>*/}
      {/*        </div>*/}
      {/*        <div className={'bv-img animate__animated animate__fadeInDown'}>*/}
      {/*            <img className={'lbl-logo animate__animated animate__fadeIn'}*/}
      {/*                 src={require("../../../assets/img/chrome.png")}*/}
      {/*                 alt="NTB online banking"/>*/}
      {/*        </div>*/}
      {/*        <div className={'bv-img animate__animated animate__fadeInDown'}>*/}
      {/*            <img className={'lbl-logo animate__animated animate__fadeIn'}*/}
      {/*                 src={require("../../../assets/img/opera.png")}*/}
      {/*                 alt="NTB online banking"/>*/}
      {/*        </div>*/}
      {/*        <div className={'bv-img animate__animated animate__fadeInDown'}>*/}
      {/*            <img className={'lbl-logo animate__animated animate__fadeIn'}*/}
      {/*                 src={require("../../../assets/img/safari.png")}*/}
      {/*                 alt="NTB online banking"/>*/}
      {/*        </div>*/}
      {/*    </div>*/}
      {/*    <div className={'bv-text animate__animated animate__fadeInDown'}>*/}
      {/*        Best view in*/}
      {/*    </div>*/}
      {/*</div>*/}
      {/*}*/}

      {/*<div className={"footer-all-right-wrp justify-content-center animate__animated animate__fadeInDown mb-1"}>
        © 2021{" "}
        <a href="https://www.nationstrust.com/" target="_blank" rel="noreferrer noopener">
          Nations Trust Bank.
        </a>{" "}
        All Rights Reserved
      </div>*/}
    </div>
  </>
);
export default Index;
